// @ts-check

import {
  GET_WEBHOOKS,
  CREATE_WEBHOOK,
  UPDATE_WEBHOOK,
  DELETE_WEBHOOK,
  GET_USER_VISIBLE_COLUMNS
} from './actionTypes';
import { getActionStatusName } from '@/store/helpers';

export const changeLogFeatureFlag = state => {
  return state.currentAccountFeatureFlags.changelog;
};

export const getWebhooksStatus = state => state.status[getActionStatusName(GET_WEBHOOKS)] || {};
export const createWebhookStatus = state => state.status[getActionStatusName(CREATE_WEBHOOK)] || {};
export const updateWebhookStatus = state => state.status[getActionStatusName(UPDATE_WEBHOOK)] || {};
export const deleteWebhookStatus = state => state.status[getActionStatusName(DELETE_WEBHOOK)] || {};
export const getUserVisibleColumnsStatus = state => state.status[getActionStatusName(GET_USER_VISIBLE_COLUMNS)] || {};
